import "./axios";
import "./vuetify";
import "./v-debounce";
import "./vm-progress";
import "./vue-apexchart";
import "./global-components";
import xl_tables from "./excelExport/xl_tables";

import Vue from "vue";
import { store } from "@/store";
import vAlert from "./vue-alert-component";

Vue.use(vAlert);
window.XlsxPopulate = require("xlsx-populate");

Vue.mixin({
  methods: {
    userCan(value) {
      return store.getters["AuthModule/permissions"].includes(value);
    },
    can(permission) {
      return store.getters["AuthModule/permissions"].includes(permission);
    },
    xl_tables,

    prettyAnswer(answer) {
      if (answer == -1) return "PRO-RATED";
      else return answer;
    },

    prettySection(section) {
      if (section == 1) return "Internal Governance and Strategic Management";
      else if (section == 2) return "Project Management and Program Delivery";
      else if (section == 3) return "Financial Management";
      else if (section == 4) return "Human Resources";
      else if (section == 5)
        return "External Relations, Communications and Outreach";
      else return section;
    },

    downloadReport(cso, reportType) {
      this.axios({
        method: "GET",
        responseType: "blob",
        url: `download-file?file=${cso[reportType]}`
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `${cso.id}-${cso.name} ${this.$t(reportType)}.docx`
        );
        document.body.appendChild(link);
        link.click();
      });
    }
  },
  data() {
    return {
      APP_NAME: "AICS", //
      per_page: [
        5,
        10,
        25,
        {
          text: "$vuetify.dataIterator.rowsPerPageAll",
          value: -1
        }
      ],
      PTS_LOGO: require("../assets/images/pts.svg"),
      APP_LOGO: require("../assets/images/logo.jpg")
    };
  }
});
